/**
 *
 * @param el
 */
function selectElementContents(el) {
  const range = document.createRange();
  range.selectNodeContents(el);
  const sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
}

/**
 *
 * @param str
 */
export function writeToClipboardExecCommand(str) {
  const el = document.createElement('div'); // Create a <textarea> element
  el.setAttribute('content-editable', true);
  el.innerHTML = str; // Set its value to the string that you want copied
  el.setAttribute('readonly', ''); // Make it readonly to be tamper-proof
  el.style.position = 'absolute';
  el.style.left = '-9999px'; // Move outside the screen to make it invisible
  el.style.backgroundColor = '#ffffff'; // default bgcolor is gray make white
  document.body.appendChild(el); // Append the <textarea> element to the HTML document
  // Check if there is any content selected previously
  const selected = document.getSelection().rangeCount > 0
    ? document.getSelection().getRangeAt(0) // Store selection if found
    : false; // Mark as false to know no selection existed before
  selectElementContents(el); // Select the <textarea> content
  document.execCommand('copy'); // Copy - only works as a result of a user action (e.g. click events)
  document.body.removeChild(el); // Remove the <textarea> element
  if (selected) { // If a selection existed before copying
    document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
    document.getSelection().addRange(selected); // Restore the original selection
  }
  return { selected, str, el };
}

/**
 *
 * @param content
 * @param isHtml
 */
export function writeToClipboardApi(content, isHtml = false) {
  const type = isHtml ? 'text/html' : 'text/plain';
  const blob = new Blob([content], { type });
  const clipboardItem = new window.ClipboardItem({ [type]: blob });

  return navigator.clipboard.write([clipboardItem]);
}
